import { FC } from "react";
import { CSSTransition } from "react-transition-group";
import { CSSTransitionProps } from "react-transition-group/CSSTransition";

type Props = PartialByKey<CSSTransitionProps, "addEndListener">;

export const Transition: FC<Props> = ({
  children,
  unmountOnExit = true,
  addEndListener = () => {},
  ...props
}) => (
  <CSSTransition
    {...props}
    unmountOnExit={unmountOnExit}
    addEndListener={addEndListener}
  >
    {children}
  </CSSTransition>
);
